module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr13-d54837aab8687394e51792f1768895fd.jpg";